import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';

const useNetworkStatus = (setIsOffline) => {
    useEffect(() => {
        const handleOnline = () => {
            // toast.success("Internet connection restored!");
            setIsOffline(false); // Set offline status to false
        };

        const handleOffline = () => {
            // toast.error("Internet connection lost!");
            setIsOffline(true); // Set offline status to true
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Initial check
        setIsOffline(!navigator.onLine);

        // Cleanup event listeners on component unmount
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [setIsOffline]);
};

export default useNetworkStatus; 